import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet';
function TestUrl() {

    // In your post component
useEffect(() => {
  document.title = 'post.title';
  const metaTags = [
    { property: 'og:title', content: 'post.title' },
    { property: 'og:description', content: 'post.description' },
    { property: 'og:image', content: 'https://www.shutterstock.com/image-vector/background-social-media-proportions-web-260nw-1029387880.jpg' },
    { property: 'og:url', content: 'https://www.shutterstock.com/image-vector/background-social-media-proportions-web-260nw-1029387880.jpg' }
  ];
  
  metaTags.forEach(tag => {
    let element = document.querySelector(`meta[property="${tag.property}"]`);
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute('property', tag.property);
      document.head.appendChild(element);
    }
    element.setAttribute('content', tag.content);
  });
}, []);
  return (
    <>
      <Helmet>
        <title>Post</title>
        <meta name="description" content='this is the description' />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://Lookflock.com/posts/123`} />
        <meta property="og:title" content='hi world' />
        <meta property="og:description" content='we are working' />
        <meta property="og:image" content='https://www.shutterstock.com/image-vector/background-social-media-proportions-web-260nw-1029387880.jpg' />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={`https://yourwebsite.com/posts/123`} />
        <meta name="twitter:title" content='hi world' />
        <meta name="twitter:description" content='we are working' />
        <meta name="twitter:image" content='https://www.bigfootdigital.co.uk/wp-content/uploads/2020/07/image-optimisation-scaled.jpg'/>
      </Helmet>
      
      {/* Your post content */}
      <div className="post">
        {/* ... */}
      </div>
    </>
  )
}

export default TestUrl